import { MenuList as ChakraMenuList } from '@chakra-ui/react';

export const MenuListNoPadding = ({ children }) => <ChakraMenuList p={0}>{children}</ChakraMenuList>;
